import React from "react";

function RefreshIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="12"
      fill="none"
      viewBox="0 0 13 12"
    >
      <path
        stroke="#B4B4B4"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25"
        d="M12.417 1.333v3.5m0 0h-3.5m3.5 0L9.716 2.29a5.25 5.25 0 101.237 5.46"
      ></path>
    </svg>
  );
}

export default RefreshIcon;
